import { render, staticRenderFns } from "./friendScores.vue?vue&type=template&id=b0dd692e&"
import script from "./friendScores.vue?vue&type=script&lang=js&"
export * from "./friendScores.vue?vue&type=script&lang=js&"
import style0 from "./friendScores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports